import {store} from 'store';

export function printSidebar() {
  store.dispatch({
    type: 'UI_PRINT',
    target: 'sidebar'
  });
}

export function printMain() {
  store.dispatch({
    type: 'UI_PRINT',
    target: 'main'
  });
}
